import React, {useState} from 'react';

const SpecialtyCard = ({specialty}) => {
  return (
    <div className='large-4 medium-6 small-12 columns specialty-card'>
      <img src={`https://gallery.cureusjournals.com/collection/${specialty.image_name}.png`}/>
      <p>{specialty.name}</p>
      <br></br>
      <div className="hovered-content">
        <ul>
          { specialty.categories.map((item,i) => <li key={i}>{item}</li>) }
        </ul>
      </div>
    </div>
  )
}

export default SpecialtyCard;